import React, { useState, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { Box, Container } from '@material-ui/core'
import CustomerListResults from '../components/customer/CustomerListResults'
import CustomerListToolbar from '../components/customer/CustomerListToolbar'
import Loader from '../components/utils/Loader'
import { getPublicAPI } from '../api'
import { ShoppingCartContext } from '../contexts/ShoppingCart'
import SearchResult from '../components/SearchResult'

const CustomerList = () => {
   const navigate = useNavigate()
   const [loading, setLoading] = useState(true)
   const [users, setUsers] = useState([])
   const [customers, setCustomers] = useState([])
   const {
      searchC,searchCustomer
   } = useContext(ShoppingCartContext)

   useEffect(() => {
      let mounted = true

      setTimeout(() => {
         if (!localStorage.auth_token || localStorage.user_type === 'customer') navigate('/login')
         mounted && setLoading(false)
      }, 1000)

      async function fetchUsers() {
         let allUsers = await getPublicAPI(`/users`)
         if (allUsers?.success) {
            setUsers(allUsers.data)
            setCustomers(allUsers.data)
         }
      }
      fetchUsers()

      return () => (mounted = false)
   }, [navigate])


   useEffect(() => {
      let selected = []
      if (searchCustomer) {
         selected = customers.filter(
            customer =>
            (customer.fName.toLowerCase().includes(searchCustomer?.toLowerCase()) ||
               customer.email.toLowerCase().includes(searchCustomer?.toLowerCase()) ||
               customer.lName.toLowerCase().includes(searchCustomer?.toLowerCase()))
         )
      }
      let fineslected = selected
      setUsers(fineslected)
      if (!searchCustomer) { setUsers(customers) }
      
   }, [searchCustomer])

   return (
      <>
         <Helmet>
            <title>{loading ? 'Loading...' : 'Customers | The HosePod'}</title>
         </Helmet>
         <Box
            sx={{
               backgroundColor: 'background.default',
               minHeight: '100%',
               py: 3
            }}
         >
            <Container maxWidth={false}>
               {loading ? (
                  <Loader />
               )
                  : searchC ?
                     (
                        <SearchResult />
                     )
                     : (
                        <>
                           <CustomerListToolbar />
                           <Box sx={{ pt: 3 }}>
                              <CustomerListResults users={users} />
                           </Box>
                        </>
                     )}
            </Container>
         </Box>
      </>
   )
}

export default CustomerList
